import { DeviceMigrationState, DeviceMigrationActionTypes, deviceMigrationActionNames } from './types';

const initialState: DeviceMigrationState = {
  isLoading: false
};

export const deviceMigrationReducer = (
  state: DeviceMigrationState = initialState,
  action: DeviceMigrationActionTypes,
): DeviceMigrationState => {
  switch (action.type) {
    case deviceMigrationActionNames.SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      }
    }
    default:
      return state;
  }
};
